import React, { useContext, useEffect, useState } from "react";
import { Colorcontext } from "../../Component/Colorcontext/ColorContext";
import directoryimage from "../../Images/directoryimage.png";
import mobilecopy from "../../Images/image_about directory.png";
import Reward from "../../Images/Reward.png";
import network from "../../Images/network.png";
import infos from "../../Images/infos.png";
import visual from "../../Images/visual.png";
import post from "../../Images/post.png";
import social from "../../Images/social.png";
import chat from "../../Images/chat.png";
import brief from "../../Images/brief.png";
import { Link } from "react-router-dom";
import SeoGeneral from '../BusinessPage/SeoGeneral';

const Businessdirectory = () => {
  const colordata = useContext(Colorcontext);
  useEffect(() => {
    colordata.setcolor(true);
    return () => {
      colordata.setcolor(false);
    };
  }, []);

  const seoMetaData = {
    title: "About Online Business Directory | Neoo Search",
    description: "Learn about the Neoo Search B2B online business directory, built to help businesses connect with customers, boost visibility, and grow across UAE, India, and GCC.",
    ogImage: "https://neoosearch.com/static/media/Admin_chat%20logo.7fa36f039461d205a125.png",
    ogImageAlt: "About Online Business Directory | Neoo Search",
    url: process.env.REACT_APP_APPLICATION_URL + "/about-business-directory",
    keywords: "Online business directory in UAE, India, and GCC, List your business in a B2B directory, SEO-friendly business directory platform, Find verified business listings online, Local and regional business directory services, B2B sales and marketing platform, Offer business listings for companies",
    type: "website",
    site_name: "NeooSearch",
    canonical: process.env.REACT_APP_APPLICATION_URL + "/about-business-directory"
  };

  return (
    <>
      <SeoGeneral data={seoMetaData} />
      <section className="searchloginmain">
        <div className="cust_container">
          <div className="bg-wht">
            <div className="bannerloginbg">
              <img src={directoryimage} alt="..." />
              <div className="bannerloginbgcontent">
                <h4 className="busineeheadparadirecrpara">
                  List your business in Neoo Search and grow fast
                </h4>
                <p className="businesssubparaparasecrtstt">
                  Discover and evaluate top local companies by joining the
                  fastest-growing directory of small and large businesses.
                </p>
                <div className="freebusinessbtndibmaoin">
                  <Link className="freebusinessbtn" to="/business-directory-listing-pricing">
                    Business Listing
                  </Link>
                </div>
              </div>
            </div>

            <div className="businedirreidovmain">
              <p className="businedirreidovmainttxpp">
                Search is a leading local search engine and online business directory that helps businesses increase visibility and rank higher on search engines. With Neoo Search, you can find businesses near you on a local search engine, connecting with the right products, services, and brands in your area. Our extensive database of regional business listings promotes your offerings to the right audience. By combining the best features of local SEO, social media integration, and business directories, Neoo Search benefits both businesses and customers, making it easier to connect, discover, and grow.
              </p>
            </div>

            <div className="businedirreidovmainnedpoing">
              <div className="businedirreidovmainnedpoingdibvlcx">
                <div className="mobilecopydivimage">
                  <img src={mobilecopy} alt="..." />
                </div>

                <div className="businedirreidovmainnedpoingdiright">
                  <div className="businedirreidovmainnedpoingdimain">
                    <h4 className="buiisconnesttxtppp">
                      Build contacts with clients
                    </h4>
                    <p className="sennjandrecetxtpp">
                      Send and receive enquiries
                    </p>
                  </div>
                  <div className="businedirreidovmainnedpoingdimain">
                    <h4 className="buiisconnesttxtppp">
                      Manage your business profile
                    </h4>
                    <p className="sennjandrecetxtpp">
                      Update your product and services information and increase
                      your online reach
                    </p>
                  </div>
                  <div className="businedirreidovmainnedpoingdimain">
                    <h4 className="buiisconnesttxtppp">
                      Promote and connect your business
                    </h4>
                    <p className="sennjandrecetxtpp">
                      Showcase your products and services and reach out to your
                      customers
                    </p>
                  </div>
                  <div className="businedirreidovmainnedpoingdimain">
                    <h4 className="buiisconnesttxtppp">
                      Monitor your profile analytics
                    </h4>
                    <p className="sennjandrecetxtpp">
                      Send and receive enquiries
                    </p>
                  </div>
                  <div className="businedirreidovmainnedpoingdimain">
                    <h4 className="buiisconnesttxtppp">
                      Build contacts with clients
                    </h4>
                    <p className="sennjandrecetxtpp">
                      Get performs report from analytics
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-whtdivnmanb">
            <div className="">
              <h4 className="makednekleosearchtxtpp">
                What makes Neoo Search the best online business directory?
              </h4>

              <p className="WhatmakesNeoosearchtxtp">
                It’s fast and easy to use, helping you quickly find the information you need. As the fastest-growing business directory for all kinds of companies, Neoo Search allows businesses to showcase their products and services, post daily updates, and connect with customers directly through sending and receiving enquiries.
              </p>

              <p className="WhatmakesNeoosearchtxtp">
               Neoo Search also functions as the ideal local business directory, giving businesses a unique set of advantages beyond simple search. Boost your online visibility, expand your business network, and stay ahead in search results with Neoo Search—your go-to platform for business growth and customer engagement.
              </p>
            </div>
            <div className="bg-whtdivnmanbdivmaimaindiv">
              <div className="bg-whtdivnmanbdivmaidfflex">
                <div className="bg-whtdivnmanbdivmaimdivfexrt">
                  <div className="rewarddibbabimgahsdimg">
                    <img src={brief} alt="..." />
                  </div>
                  <div className="">
                    <p className="Promotetxtpp">Promote Your Local Business</p>
                    <p className="freetetxtppp">
                      A free platform to enhance your online visibility and
                      advertise your goods and services
                    </p>
                  </div>
                </div>

                <div className="bg-whtdivnmanbdivmaimdivfexrt">
                  <div className="rewarddibbabimgahsdimg">
                    <img src={network} alt="..." />
                  </div>
                  <div className="">
                    <p className="Promotetxtpp">Build business Networking</p>
                    <p className="freetetxtppp">
                      Establish connections with businesses and target
                      customers.
                    </p>
                  </div>
                </div>

                <div className="bg-whtdivnmanbdivmaimdivfexrt">
                  <div className="rewarddibbabimgahsdimg">
                    <img src={infos} alt="..." />
                  </div>
                  <div className="">
                    <p className="Promotetxtpp">Key Business Information</p>
                    <p className="freetetxtppp">
                      Give your audience all the information they require about
                      your business.
                    </p>
                  </div>
                </div>

                <div className="bg-whtdivnmanbdivmaimdivfexrt">
                  <div className="rewarddibbabimgahsdimg">
                    <img src={visual} alt="..." />
                  </div>
                  <div className="">
                    <p className="Promotetxtpp">Visual Impact</p>
                    <p className="freetetxtppp">
                      To keep your customers interested, incorporate videos and
                      images
                    </p>
                  </div>
                </div>

                <div className="bg-whtdivnmanbdivmaimdivfexrt">
                  <div className="rewarddibbabimgahsdimg">
                    <img src={post} alt="..." />
                  </div>
                  <div className="">
                    <p className="Promotetxtpp">Enquiry post</p>
                    <p className="freetetxtppp">
                      Add enquiry posts to your listing to showcase your latest
                      updates.
                    </p>
                  </div>
                </div>

                <div className="bg-whtdivnmanbdivmaimdivfexrt">
                  <div className="rewarddibbabimgahsdimg">
                    <img src={Reward} alt="..." />
                  </div>
                  <div className="">
                    <p className="Promotetxtpp">Business rewards</p>
                    <p className="freetetxtppp">
                      Magical reward points for your business promotions
                    </p>
                  </div>
                </div>

                <div className="bg-whtdivnmanbdivmaimdivfexrt">
                  <div className="rewarddibbabimgahsdimg">
                    <img src={social} alt="..." />
                  </div>
                  <div className="">
                    <p className="Promotetxtpp">Social Media</p>
                    <p className="freetetxtppp">
                      Include connections to your social media accounts.
                    </p>
                  </div>
                </div>

                <div className="bg-whtdivnmanbdivmaimdivfexrt">
                  <div className="rewarddibbabimgahsdimg">
                    <img src={chat} alt="..." />
                  </div>
                  <div className="">
                    <p className="Promotetxtpp">Real time chat</p>
                    <p className="freetetxtppp">
                      Improve customer’s engagement and retention
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Businessdirectory;
